import { render } from "./NewsDetailsBanner.vue?vue&type=template&id=6ff30995"
import script from "./NewsDetailsBanner.vue?vue&type=script&lang=js"
export * from "./NewsDetailsBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__